module.exports = {
  PENDING: 0,
  SUCCESS: 1,
  REJECTED: 2,
  ACTIVE: 3,
  FINISHED: 4,
  CANCELLED: 5,
  RETRY_LIMIT: 6,
  CC_EXPIRED: 7,
  NEGOTIATED: 9
};